import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useWorldStore } from "../stores/world.js";
import { useSettingsStore } from "../stores/settings.js";

export function useKeyboardShortcuts() {
  const navigate = useNavigate();
  const { mode, setMode } = useWorldStore();
  const { toggleSidebar, toggleFeedbackPanel, toggleRightPanel } = useSettingsStore();

  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      const target = e.target as HTMLElement;
      const isInput =
        target.tagName === "INPUT" ||
        target.tagName === "TEXTAREA" ||
        target.tagName === "SELECT" ||
        target.isContentEditable;

      // Cmd+K is handled by cmdk directly
      // Cmd+B: Toggle sidebar
      if ((e.metaKey || e.ctrlKey) && e.key === "b") {
        e.preventDefault();
        toggleSidebar();
        return;
      }

      // Cmd+J: Toggle feedback panel
      if ((e.metaKey || e.ctrlKey) && e.key === "j") {
        e.preventDefault();
        toggleFeedbackPanel();
        return;
      }

      // Cmd+.: Toggle right panel
      if ((e.metaKey || e.ctrlKey) && e.key === ".") {
        e.preventDefault();
        toggleRightPanel();
        return;
      }

      // Only process non-modified keys if not in an input
      if (isInput) return;

      // M: Toggle monitor/design
      if (e.key === "m" || e.key === "M") {
        setMode(mode === "monitor" ? "design" : "monitor");
        return;
      }

      // Cmd+1: Dashboard
      if ((e.metaKey || e.ctrlKey) && e.key === "1") {
        e.preventDefault();
        navigate("/");
        return;
      }

      // Cmd+2: Topology
      if ((e.metaKey || e.ctrlKey) && e.key === "2") {
        e.preventDefault();
        navigate("/topology");
        return;
      }

      // Cmd+3: Settings
      if ((e.metaKey || e.ctrlKey) && e.key === "3") {
        e.preventDefault();
        navigate("/settings");
        return;
      }
    }

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [mode, setMode, navigate, toggleSidebar, toggleFeedbackPanel, toggleRightPanel]);
}
